import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const ApplyTaskTemplateDialogTourConfig: AgTechTourConfig = {
    id: 'apply-task-template-dialog-tour',
    name: 'Apply Template Tour',
    steps: [
        {
            targetId: 'apply-template-select',
            title: 'Choose a Template',
            description: 'Pick a task template. Applying it creates one planning task per template item, with dates calculated from this sale start date. Manage templates under Settings > Task Templates.',
            position: 'bottom',
        },
    ]
}
